import React from 'react';
import { Col, Row } from 'antd';
import { I18n } from '@aws-amplify/core';

import { isClipCorrupted, isClipReady } from '../utils';
import type { AnalyzedActivity } from '../utils';
import { FileError, FileLink, FileName } from './styles';

interface FileCellProps {
	activity: AnalyzedActivity;
	onOpen: (activity: AnalyzedActivity) => void;
	onRetry: (activity: AnalyzedActivity) => void;
	retrying: boolean;
}

export function FileCell({ activity, onOpen, onRetry, retrying }: Readonly<FileCellProps>): JSX.Element {
	function handleClick(): void {
		onOpen(activity);
	}

	function handleRetry(): void {
		onRetry(activity);
	}

	if (isClipCorrupted(activity)) {
		return (
			<Row>
				<Col span={24}>
					<FileLink type="button" disabled={retrying} onClick={handleRetry}>
						{I18n.get('Redo')}
					</FileLink>
				</Col>
				{!!activity.processing_error && (
					<Col span={24}>
						<FileError>{activity.processing_error}</FileError>
					</Col>
				)}
			</Row>
		);
	}

	if (!isClipReady(activity)) {
		return <FileName>{activity.file_name}</FileName>;
	}

	return (
		<FileLink type="button" onClick={handleClick}>
			{activity.file_name}
		</FileLink>
	);
}
